import React, { useCallback, useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
const BUYERS = ['María López de Buenos Aires', 'Juan Pérez de Córdoba', 'Ana García de Rosario', 'Carlos Rodríguez de Mendoza', 'Laura Fernández de Tucumán', 'Diego Martínez de Mar del Plata', 'Sofía Hernández de Salta', 'Pablo Gómez de Santa Fe', 'Florencia Díaz de Neuquén', 'Tomás Ruiz de Bahía Blanca'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState('');
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const showPopup = useCallback(() => {
    const randomBuyer = BUYERS[Math.floor(Math.random() * BUYERS.length)];
    setCurrentBuyer(randomBuyer);
    setIsVisible(true);
    // Hide after 5s, then schedule next
    timeoutRef.current = setTimeout(() => {
      setIsVisible(false);
      const nextDelay = 8000 + Math.random() * 4000;
      timeoutRef.current = setTimeout(showPopup, nextDelay);
    }, 5000);
  }, []);
  useEffect(() => {
    timeoutRef.current = setTimeout(showPopup, 5000);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [showPopup]);
  return <AnimatePresence data-id="element-194">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -100,
      transition: {
        duration: 0.3
      }
    }} className="fixed bottom-4 left-4 z-50 bg-[#1a0533] border border-[#a855f7] rounded-lg p-4 shadow-2xl max-w-sm flex items-center gap-4" data-id="element-195">
          <div className="bg-[#a855f7]/20 p-2 rounded-full" data-id="element-196">
            <ShoppingCartIcon className="w-6 h-6 text-[#a855f7]" data-id="element-197" />
          </div>
          <div data-id="element-198">
            <p className="text-sm text-white font-medium" data-id="element-199">
              🛒{' '}
              <span className="font-bold text-[#FFD700]" data-id="element-200">{currentBuyer}</span>
            </p>
            <p className="text-xs text-[#c4b5d4] mt-1" data-id="element-201">
              acaba de comprar este curso
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}